import apiClient from './apiClient';
import RetreatCourseDataStore from '@/data/datastores/RetreatCourseDataStore';
import { retreatCourses as retreatCourseSchema } from './schemas';

class RetreatCourseDataStoreGraphQL implements RetreatCourseDataStore {
  client = apiClient();

  async registerWithdrawalCourses(procedureId: number, coursesWithdrawal: any) {
    try {
      const response = await this.client.mutate({
        mutation: retreatCourseSchema.registerWithdralCourses,
        variables: { procedureId, coursesWithdrawal }
      });
      const { data } = response;

      return data.registerWithdrawalCourses;
    } catch (error) {
      throw new Error('Error "registerWithdrawalCourses"');
    }
  }

  async activateWithdrawalCourses(requestId: number) {
    try {
      const response = await this.client.mutate({
        mutation: retreatCourseSchema.activateWithdrawalCourses,
        variables: { requestId }
      });
      const { data } = response;
      return data.activateWithdrawalCourses;
    } catch (error) {
      throw new Error('Error "activateWithdrawalCourses"');
    }
  }
}

export default RetreatCourseDataStoreGraphQL;
